import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button} from '../../../components'
import {
  Container,
  Title,
  FlowSummaryPanelItem,
  FlowSummaryLastPanelItem,
  Link,
  FlowItemPanelWithCross,
} from '../../flow'
import {Panel, LoadingIndicator} from '../../../components'
import TextField from 'material-ui/TextField'
import Dialog, {DialogTitle, DialogActions, DialogContent} from 'material-ui/Dialog'
import List, {ListItem} from 'material-ui/List'
import {paymentMethod as text} from '../../profile/text'
import {CardIcon} from '../../../common/components/CreditCardInput'
import Typography from 'material-ui/Typography'
import MUIButton from 'material-ui/Button'
import {formatAddress} from '../../../common/format'
import {PRICES_AVAILABLE} from "../../../App"
import OfflineIcon from 'material-ui-icons/PhonelinkOff'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {margin: '5px 0'},
  noCatalogsMessage: {
    marginTop: 35,
    color: 'rgba(0,0,0,.54)',
    textAlign: 'center',
  },
  textContainer: {
    padding: '0 10px',
  },
  lastActionContainer: {
    padding: '5px 16px',
    textAlign: 'right',
  },
})

class SummaryStep extends React.Component {

  static displayName = 'SummaryStep.component'

  state = {
    open: false,
    cardError: false,
    selectedOffline: false,
  }

  render() {
    const {classes, items, address, dateStart, dateEnd, card, comment, isConfirming, requireCardForDeposit} = this.props
    const transactionCost = this.props.deliveryCost + this.props.pickupCost
    return (
      <Container className={classes.container}>
        <Title className={classes.title}>Chequea la información:</Title>
        <Panel style={{marginBottom: 10}}>
          {items.map(item => {
            const photos = item.has('Photos') ? item.get('Photos') : item.get('Photo') // Inconsistency in data coming from server
            const mainPhoto = photos.find(p => p.MainPhoto === true)
            let photoUrl = ''
            if (mainPhoto) photoUrl = mainPhoto.Url
            return (
              <FlowItemPanelWithCross
                key={item.get('ID')}
                name={item.get('Name')}
                imgSrc={photoUrl}
                isButton={false}
              />
            )
          })}
        </Panel>
        <Panel>
          <FlowSummaryPanelItem
            title={'Dirección de envío'}
            description={formatAddress(address.Address, address.Number, address.Floor, address.Apartment, '')}
            actionLabel={'Modificar'}
            onClick={() => this.props.requestPreviousStep()}
          />
          <FlowSummaryPanelItem
            title={'Recibiré los ítems el:'}
            description={dateStart ? dateStart.format('LLL') : 'No seleccionada'}
            actionLabel={'Modificar'}
            onClick={() => this.props.requestPreviousStep()}
          />
          <FlowSummaryPanelItem
            title={'Devolveré los ítems el:'}
            description={dateEnd === null ? 'No devolveré los ítems' : dateEnd.format('LLL')}
            actionLabel={'Modificar'}
            onClick={() => this.props.requestPreviousStep()}
          />
          <FlowSummaryPanelItem
            title={'Método de Pago'}
            description={
              this.state.selectedOffline === true
                ? 'Pago offline'
                : card ? `${card.Type} terminada en ${card.LastDigits}` : 'Seleccionar'
            }
            actionLabel={'Modificar'}
            onClick={() => this.setState({open: true, cardError: false})}
            error={this.state.cardError}
            warning={this.state.selectedOffline === false && !card}
          />
          {PRICES_AVAILABLE &&
            <FlowSummaryLastPanelItem
              rows={[{
                label: 'Costo de envío',
                value: transactionCost === 0 ? '¡GRATIS!' : '$' + transactionCost,
                valueColor: transactionCost === 0 ? 'secondary' : undefined,
              }]}
            />
          }

        </Panel>
        <TextField
          fullWidth={true}
          label={'Comentarios'}
          style={{margin: '15px 0 25px 0'}}
          value={comment}
          onChange={(e) => this.props.setComment(e.target.value)}
        />
        <LoadingIndicator show={isConfirming || this.props.loading}>
          <Button
            variant={'primary'}
            fullWidth={true}
            className={classes.button}
            onClick={() => {
              if (this.state.selectedOffline === false && !card) {
                this.setState({cardError: true})
              } else {
                this.props.confirm()
              }
            }}
          >
            Confirmar
          </Button>
        </LoadingIndicator>
        <SelectCardDialog
          classes={classes}
          open={this.state.open}
          onClose={() => this.setState({open: false})}
          onCancel={() => this.setState({open: false})}
          modalTitle={'Selecciona una tarjeta'}
          options={this.props.cards}
          onSelect={(card) => {
            this.props.selectCard(card)
            this.setState({open: false})
            this.setState({
              open: false,
              selectedOffline: card === -1,
            })
          }}
          lastAction={{
            label: 'Agregar tarjeta',
            onClick: this.props.goToPayment,
          }}
          allowOffline={requireCardForDeposit === false}
        />
      </Container>
    )
  }

  static propTypes = {
    requireCardForDeposit: PropTypes.bool,
    items: PropTypes.array,
    address: PropTypes.object,
    dateStart: PropTypes.object,
    dateEnd: PropTypes.object,
    card: PropTypes.object,
    cards: PropTypes.array,
    comment: PropTypes.string,
    selectCard: PropTypes.func.isRequired,
    setComment: PropTypes.func.isRequired,
    rentPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    pickupCost: PropTypes.number,
    confirm: PropTypes.func.isRequired,
    isConfirming: PropTypes.bool,
    requestPreviousStep: PropTypes.func.isRequired,
    goToPayment: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(SummaryStep)

const SelectCardDialog = ({classes, open, onClose, onCancel, modalTitle, options, onSelect, lastAction, allowOffline}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle align={'center'}>{modalTitle}</DialogTitle>
    <DialogContent style={{minWidth: 320, padding: 0}}>
      <List>
        {options.map(c => (
          <ListItem key={c.ID} button onClick={() => onSelect(c.ID)}>
            <CardIcon type={c.Type} style={{width: 36, height: 36, marginRight: 20}}/>
            <div className={classes.textContainer}>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{`•••• •••• •••• ${c.LastDigits}`} ({c.Type})</Typography>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{text.expiryDate}: {c.Expiration}</Typography>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{c.Main ? 'Tarjeta Primaria' : ''}</Typography>
            </div>
          </ListItem>
        ))}
        {allowOffline && options.length === 0 && (
          <ListItem key={-1} button onClick={() => onSelect(-1)}>
            <OfflineIcon style={{width: 36, height: 36, marginRight: 20}}/>
            <div className={classes.textContainer}>
              <Typography variant={'body1'} color={'textSecondary'}>Pagar offline</Typography>
            </div>
          </ListItem>
        )}
        {lastAction && (
          <div className={classes.lastActionContainer}>
            <Link onClick={lastAction.onClick}>{lastAction.label}</Link>
          </div>
        )}
      </List>
    </DialogContent>
    <DialogActions>
      <MUIButton onClick={onCancel} color={'primary'}>Cancelar</MUIButton>
    </DialogActions>
  </Dialog>
)



// WEBPACK FOOTER //
// ./src/sections/remove/components/summary.step.jsx